import { call, put, takeLatest } from 'redux-saga/effects';
import { filter, find } from 'lodash';
import { getBannerList, closeBanner } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess, setShowTourStatus } from './actions';

function* getInfo() {
  const response = yield call(getBannerList);
  if (response.isOk) {
    const bannersData = filter(response.data, 'banner');
    yield put(requestSuccess(bannersData));
    yield put(setShowTourStatus(!!find(response.data, { messageId: -1 })));
  } else {
    return yield put(requestFailure(response.error));
  }
}

function* closeTourBanner(action) {
  if (action.payload.isClosed) {
    yield closeBanner(-1);
  }
}

export default function* bannerListSaga() {
  yield takeLatest(actionTypes.START_REQUEST, getInfo);
  yield takeLatest(actionTypes.IS_SHOW_TOUR, closeTourBanner);
}
